var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resGray lighten-6"},[(_vm.estimatesActive)?_c('estimates',{on:{"openCyclePage":_vm.openCyclePage}}):_vm._e(),(_vm.cyclesActive)?_c('add-estimates',{attrs:{"poolInfo":_vm.poolInfo},on:{"openPoolsPage":_vm.openPoolsPage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }